import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@bitcoin-portal/verse-web-components/dist/Button';
import ArrowRight from '@bitcoin-portal/verse-web-components/dist/Icons/ArrowRight';
import Title from '@bitcoin-portal/verse-web-components/dist/Title';

import { Banner, ButtonWrapper, Content, StyledLink, Wrapper } from './styled';

const CardBanner: FunctionComponent = () => {
  return (
    <Wrapper>
      <Banner>
        <StyledLink href="/card" target="_blank">
          <Content>
            <Title>
              <FormattedMessage id="global.card-banner.title" />
            </Title>
            <ButtonWrapper>
              <Button as="div" small>
                <span
                  style={{
                    padding: '0 8px',
                    display: 'flex',
                    flexFlow: 'row nowrap',
                    alignItems: 'center',
                  }}
                >
                  <FormattedMessage id="global.card-banner.button" />
                  <ArrowRight
                    size={10}
                    style={{ paddingLeft: 4, paddingTop: 2 }}
                  />
                </span>
              </Button>
            </ButtonWrapper>
          </Content>
        </StyledLink>
      </Banner>
    </Wrapper>
  );
};

export default CardBanner;
